import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';

import {
  SimP1StatusEnum,
  SimP1StatusEnumText,
} from '../../../common/spdCore/validation/enums';

const CONFIG: Record<
  SimP1StatusEnum,
  null | { Icon: React.ElementType; className: string }
> = {
  [SimP1StatusEnum.ToSign]: null,
  [SimP1StatusEnum.AcceptedInP1]: {
    Icon: Icon.CheckSquare,
    className: 'icon-green mt-2',
  },
  [SimP1StatusEnum.RejectedInP1]: {
    Icon: Icon.XSquare,
    className: 'icon-red mt-2',
  },
  [SimP1StatusEnum.ValidationFailed]: {
    Icon: Icon.ExclamationTriangle,
    className: 'icon-red mt-2',
  },
  [SimP1StatusEnum.WaitingForP1]: {
    Icon: Icon.Clock,
    className: 'icon-orange mt-2',
  },
};

const CANCEL_TO_SIGN_CONFIG = {
  Icon: Icon.PencilSquare,
  className: 'icon-orange mt-2',
};

const OUTDATED_CONFIG = {
  Icon: Icon.CheckSquare,
  className: 'text-secondary opacity-75 mt-2',
};

const CANCEL_ACCEPTED_CONFIG = {
  Icon: Icon.SlashSquare,
  className: 'icon-yellow mt-2',
};

const cancelTooltip = (status: SimP1StatusEnum): string => {
  switch (status) {
    case SimP1StatusEnum.AcceptedInP1:
      return 'Orzeczenie anulowane w SIM';
    case SimP1StatusEnum.ToSign:
      return 'Anulowanie w SIM czeka na podpis lekarza';
    default:
      return `Anulowanie w SIM: ${SimP1StatusEnumText[status]}`;
  }
};

export const SimP1StatusBadge = ({
  statusP1,
  cancelStatusP1,
  outdated,
}: {
  statusP1: SimP1StatusEnum | null | undefined;
  cancelStatusP1?: SimP1StatusEnum | null | undefined;
  outdated?: boolean;
}) => {
  const isCancel =
    !!cancelStatusP1 &&
    (!!CONFIG[cancelStatusP1] || cancelStatusP1 === SimP1StatusEnum.ToSign);
  const status = isCancel ? cancelStatusP1 : statusP1;
  const isOutdated =
    !!outdated && !isCancel && status === SimP1StatusEnum.AcceptedInP1;
  const config = isOutdated
    ? OUTDATED_CONFIG
    : isCancel && status === SimP1StatusEnum.ToSign
      ? CANCEL_TO_SIGN_CONFIG
      : isCancel && status === SimP1StatusEnum.AcceptedInP1
        ? CANCEL_ACCEPTED_CONFIG
        : status && CONFIG[status];
  if (!status || !config) {
    return null;
  }
  const { Icon: StatusIcon, className } = config;
  return (
    <OverlayTrigger
      overlay={
        <Tooltip style={{ position: 'fixed' }}>
          {isCancel
            ? cancelTooltip(status)
            : `${SimP1StatusEnumText[status]}${isOutdated ? ' – wersja nieaktualna' : ''}`}
        </Tooltip>
      }
    >
      <StatusIcon className={className} />
    </OverlayTrigger>
  );
};
